module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"year":"წლის","month":"თვის","male":"მამრობითი","female":"მდედრობითი"},"en":{"year":"years old","month":"months old","male":"male","female":"female"}}')
  delete Component.options._Ctor
}
